import { RuleObject } from 'antd/es/form';
import { nestedCheckboxValidationText } from '../constants/translations';

type NestedObject = {
  [key: string]: boolean | string | NestedObject;
};

export const hasTruthyValue = (inputObj: NestedObject): boolean => {
  return Object.values(inputObj).some((value) => {
    if (typeof value === 'object' && value) {
      return hasTruthyValue(value);
    }
    return Boolean(value);
  });
};

const checkboxRuleConditions = (value: boolean | NestedObject | undefined) => {
  if (typeof value === 'boolean') {
    return value;
  }
  if (typeof value === 'object' && value !== null) {
    return !hasTruthyValue(value);
  }
  return false;
};

export const customValidator = () => {
  return async (_: RuleObject, value: boolean | NestedObject | undefined) => {
    if (checkboxRuleConditions(value)) {
      return Promise.reject(new Error(nestedCheckboxValidationText));
    }

    return Promise.resolve();
  };
};
